import { render, staticRenderFns } from "./ReportRoi.vue?vue&type=template&id=2b2f4c8a"
import script from "./ReportRoi.vue?vue&type=script&lang=js"
export * from "./ReportRoi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports